import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { buildActorDirectory, type ActorDirectory } from './actorName'
import { fetchAllUsers } from './identityApi'

/**
 * Aktyor xaritasini ekranga yetkazuvchi hook (B4).
 *
 * <h2>⚠️ `enabled` SHART, ixtiyoriy emas</h2>
 * `user.read` huquqi YO'Q omborchi bu ekranlarni ochishi mumkin —
 * jurnal `inventory.stock.read` ostida, foydalanuvchilar ro'yxati esa
 * butunlay boshqa huquq ostida. `enabled` bo'lmasa so'rov yuborilib
 * 403 olardi va `react-query` uni xato deb qayta urinardi: ekran
 * ishlab turgani holda log to'lardi.
 *
 * ⚠️ Huquq yo'qligi bu yerda NOSOZLIK EMAS — xarita bo'sh qoladi va
 * `actorLabel` qisqartirilgan bo'lakka tushadi, ya'ni qiymat
 * ko'rinishda qoladi.
 *
 * ⚠️ `staleTime` 5 daqiqa: xodimlar ro'yxati jurnal qatorlari kabi
 * tez o'zgarmaydi, har sahifa ochilishida qayta so'rash esa keraksiz
 * yuk bo'lardi.
 *
 * <h2>⚠️ BU YERDA BUTUN RO'YXAT KERAK, BIR SAHIFA EMAS</h2>
 * `GET /api/users` 2026-08-20 dan sahifalangan. Xarita esa jurnaldagi
 * IXTIYORIY `actorId` ni nomga aylantiradi — bir sahifa bilan ko'p
 * qator «noma'lum» bo'lib qolardi va sababi hech qayerda ko'rinmasdi.
 * Shuning uchun `fetchAllUsers` (`fetchAllRows` sikli).
 *
 * ⚠️ Kalit `UsersPage` jadvali bilan bitta PREFIKSDA, lekin AYNI EMAS:
 * jadval kalitiga o'z holatini qo'shadi. Ya'ni ikki alohida yozuv,
 * bitta bekor qilish (`queryKeys.identity.users`) ikkalasini ham
 * yangilaydi.
 */
export function useActorDirectory(): ActorDirectory {
  const { can } = usePermissions()

  const users = useQuery({
    queryKey: queryKeys.identity.users,
    queryFn: fetchAllUsers,
    enabled: can('user.read'),
    staleTime: 5 * 60 * 1000,
  })

  return useMemo(() => buildActorDirectory(users.data ?? []), [users.data])
}
